import './checkout_fields.css';

export interface PhoneFieldProps {
  value?: string;
  onChange: (v: string) => void;
  /** Prefix for the input id/label association — kept unique per traveler in the
   *  multi-traveler drawer. Absent ⇒ the original `pc-phone` id. */
  idPrefix?: string;
  copy: { readonly label: string };
}

/** Campo de telefone obrigatório (`type="tel"`). Quem BLOQUEIA o envio é a regra
 *  do host, mas o campo precisa dizer que é obrigatório: ele costuma morar atrás
 *  de um "Editar" e, sem marca, o envio ficava cinza sem explicação. */
export function PhoneField({ value, onChange, idPrefix = '', copy }: Readonly<PhoneFieldProps>) {
  const inputId = `${idPrefix}pc-phone`;
  return (
    <div className="ctc-field">
      <label className="ctc-field-label" htmlFor={inputId}>
        {copy.label}
      </label>
      <input
        id={inputId}
        type="tel"
        required
        className="ctc-input"
        value={value ?? ''}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        aria-label={copy.label}
      />
    </div>
  );
}
